import { Link, useLocation } from 'react-router-dom';
import { adService, useAdConsent } from '@/lib/ads/AdService';

/**
 * Consentimiento de anuncios (GDPR). Solo aparece con anuncios activados y un proveedor que lo
 * necesita (AdMob): en la app, además, Google muestra su formulario UMP si la región lo exige.
 * CrazyGames y Poki gestionan su propio consentimiento. Se puede cambiar en Ajustes.
 */
export const AdConsent = () => {
  const consent = useAdConsent();
  const { pathname } = useLocation();
  if (!adService.enabled || !adService.needsConsent || consent) return null;
  // Las páginas legales se pueden leer sin que la pantalla las tape.
  if (pathname === '/privacidad' || pathname === '/terminos') return null;
  return (
    <div role="dialog" aria-modal="true" aria-labelledby="ad-consent-title" data-testid="ad-consent" className="fixed inset-0 z-[80] grid place-items-center bg-black/70 p-4">
      <div className="card-surface w-full max-w-md space-y-3 p-5 text-sm text-slate-200">
        <h2 id="ad-consent-title" className="text-display text-lg font-bold text-white">
          Tu privacidad y los anuncios
        </h2>
        <p>
          SportsArena es gratis gracias a los anuncios. Solo aparecen en pausas (entre entradas o al terminar el partido),
          nunca durante una jugada.
        </p>
        <p>
          Con tu permiso, nuestro proveedor de anuncios puede usar identificadores de tu dispositivo para mostrarte
          anuncios personalizados. Si no, verás anuncios no personalizados. Puedes cambiarlo cuando quieras en ⚙️ Ajustes.
        </p>
        <p className="text-xs text-slate-400">
          Más información en la{' '}
          <Link to="/privacidad" className="text-accent-400 hover:underline">
            política de privacidad
          </Link>
          .
        </p>
        <div className="flex flex-col gap-2 sm:flex-row">
          <button type="button" className="btn-primary h-10 flex-1 px-3 text-sm" onClick={() => adService.setConsent('personalized')}>
            Aceptar anuncios personalizados
          </button>
          <button type="button" className="btn-ghost h-10 flex-1 px-3 text-sm" onClick={() => adService.setConsent('non_personalized')}>
            Solo no personalizados
          </button>
        </div>
      </div>
    </div>
  );
};
